module.exports = __webpack_public_path__ + "media/home3-left.9f1e05b3.mp4";